import { useEffect } from 'react';

import { OneTimeProduct } from 'core/interfaces/billing';

import { useCreateOrdersProcessor } from './use-create-orders-processor';
import { useAppSelector } from 'core/store/hooks';

interface UseLoadOrdersProps {
  activeProduct?: OneTimeProduct;
  oneTimeProducts: OneTimeProduct[] | null;
  trigger: string;
  metadata: any;
  solidMetadata: any;
  onLoad?: () => void;
}

export const useLoadOrders = ({
  activeProduct,
  oneTimeProducts,
  trigger,
  metadata,
  solidMetadata,
  onLoad,
}: UseLoadOrdersProps) => {
  const email = useAppSelector((state) => state.profile.email);
  const { orderDetails, createOrders } = useCreateOrdersProcessor({
    activeProduct,
    oneTimeProducts,
    trigger,
    metadata,
    solidMetadata,
  });

  const load = () => {
    if (activeProduct?.isOneTimePurchase) {
      createOrders().then(() => onLoad && onLoad());
    }
  };

  useEffect(() => {
    load();
  }, [email, oneTimeProducts, activeProduct?.isOneTimePurchase]);

  useEffect(() => {
    window.addEventListener('online', load);

    return () => {
      window.removeEventListener('online', load);
    };
  }, []);

  return { orderDetails, createOrders };
};
